<script lang="ts">
import { defineComponent } from 'vue';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons-vue';
import { any, bool, func } from 'vue-types';

import ProfileMenu from './ProfileMenu.vue';

import GradguardLogoIcon from '@/ui/Svg/GradguardLogoIcon.vue';
import useConfig from '@/providers/config/useConfig';

export default defineComponent({
  name: 'Header',
  components: {
    ProfileMenu,
    GradguardLogoIcon,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
  },
  props: {
    class: any(),
    onShow: func<() => void>().isRequired,
    visible: bool().def(false),
  },
  setup() {
    const { config, toogleTheme, toogleCollapse } = useConfig();
    return {
      config,
      toogleTheme,
      toogleCollapse,
    };
  },
});
</script>

<template>
  <header
    :class="['px-3 flex justify-between h-12', $props.class]"
  >
    <div class="flex items-center space-x-3 md:hidden">
      <div class="w-11">
        <GradguardLogoIcon />
      </div>
      <button type="button" @click="onShow">
        <MenuFoldOutlined v-if="visible" />
        <MenuUnfoldOutlined v-else />
      </button>
    </div>
    <button
      class="bg-white dark:bg-gray-900 px-2 py-1 rounded hidden md:block"
      type="button"
      @click="toogleCollapse"
    >
      <MenuUnfoldOutlined v-if="config.collapsed" />
      <MenuFoldOutlined v-else />
    </button>
    <div class="flex">
      <ProfileMenu />
      <button
        class="h-full px-2 hover:bg-gray-100 dark:hover:bg-gray-800"
        type="button"
        @click="toogleTheme"
      >
        <FaIcon :icon="['fas', 'adjust']" />
      </button>
    </div>
  </header>
</template>
